import React from 'react';
import CheckboxListControl from '../../../components/Fields/CheckboxListControl';
import { ControlProps, FieldProps } from '../../../components/Fields/Types';
import Title from '../../../components/Headers/Title';
import useSelectListOptions from '../../../components/Hooks/SelectListOptionsHook/useSelectListOptions';
import ApplicationFeatureModel from '../../../models/ApplicationFeatureModel';

interface ApplicationFeatureControlProps {
    applicationFeature: ApplicationFeatureModel
    getFieldProps: (string) => FieldProps
    getControlProps: (string) => ControlProps
}

const ApplicationFeatureControl: React.FC<ApplicationFeatureControlProps> = ({ applicationFeature, getFieldProps, getControlProps }) => {
    const applicationFunctions = useSelectListOptions('api/v1/selectlist/ApplicationFunctions?applicationFeatureId=' + applicationFeature.id);

    function getPropName() {
        switch (applicationFeature.id) {
            case 1: return 'generalFeatures'
            case 2: return 'itemFeatures'
            case 3: return 'itemSetupFeatures'
            case 4: return 'workflowFeatures'
            case 5: return 'workflowSetupFeatures'
            case 6: return 'projectFeatures'
            case 7: return 'projectSetupFeatures'
            case 8: return 'applicationSetupFeatures'
            case 9: return 'userManagementFeatures'
            case 10: return 'businessPatnerFeatures'
            case 11: return 'licenseFeatures'
        }
    }
    let fieldProps = getControlProps(getPropName() + '.applicationFunctionIds')
    //fieldProps.width = 240

    return (
        <div>
            <Title text={applicationFeature.name} size={5} />
            <CheckboxListControl {...fieldProps } options={applicationFunctions} layout='vertical' />
        </div>
    );
}
export default ApplicationFeatureControl;